import { apiClient } from '_app'
import { ApiResponse, VehicleDto, VehicleInvoicingDto } from 'dtos'
import { InvoicingParameters } from 'parameters/invoicingParameters'
import { URIQuery } from 'utils'

export const getVehiclesEligibleForInvoicing = (parameters: InvoicingParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/invoicing/eligible-for-invoicing-vehicles` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const moveVehiclesToInvoicingServices = (vehicleGuids: string[]) =>
  apiClient.put<ApiResponse<number>>(`/api/invoicing/move-to-invoicing-services`, vehicleGuids).then(({ data }) => data)

export const getVehiclesInInvoicingServices = (parameters: InvoicingParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/invoicing/invoicing-services-vehicles` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const getVehicleInvoicing = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleInvoicingDto>>(`/api/invoicing/${encodeURIComponent(vehicleGuid)}/invoicing`)
    .then(({ data }) => data)

export const updateVehicleInvoice = (vehicleGuid: string, fieldName: string, value: number) =>
  apiClient
    .put<ApiResponse<VehicleInvoicingDto>>(`/api/invoicing/${vehicleGuid}/invoice`, {
      fieldName,
      value
    })
    .then(({ data }) => data)

export const saveAndMarkSelectedVehiclesAsReadyToInvoice = (vehicleGuids: string[]) =>
  apiClient
    .put<ApiResponse<number>>(`/api/invoicing/save-and-mark-vehicles-ready-for-invoicing`, vehicleGuids)
    .then(({ data }) => data)

export const getVehiclesReadyForInvoicing = (parameters: InvoicingParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/invoicing/ready-for-invoicing-vehicles` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const saveAndSendSelectedVehiclesToQuickBooks = (vehicleGuids: string[]) =>
  apiClient
    .put<ApiResponse<number>>(`/api/invoicing/save-and-send-vehicles-to-quickbooks`, vehicleGuids)
    .then(({ data }) => data)

export const saveAndMarkSelectedVehiclesAsInvoiced = (vehicleGuids: string[]) =>
  apiClient.put<ApiResponse<number>>(`/api/invoicing/save-and-mark-vehicles-as-invoiced`, vehicleGuids).then(({ data }) => data)

export const getVehiclesInvoiced = (parameters: InvoicingParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/invoicing/invoiced-vehicles` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const downloadInvoicingDocument = (vehicleGuid: string) =>
  apiClient
    .get<Blob>(`/api/invoicing/${encodeURIComponent(vehicleGuid)}/download-invoicing-documents`, {
      responseType: 'blob'
    })
    .then(response => response.data)

export const downloadCombinedInvoicingDocuments = (vehicleGuids: string[]) =>
  apiClient
    .post<ApiResponse<Blob>>(`/api/invoicing/documents/combined`, vehicleGuids, {
      responseType: 'blob'
    })
    .then(({ data }) => data)

// export const downloadInvoicingDocuments = (vehicleGuid: string) =>
//   apiClient
//     .get(`/api/invoicing/${encodeURIComponent(vehicleGuid)}/download-invoicing-documents`, {
//       responseType: 'blob'
//     })
//     .then(response => response.data)
